import Signup, { IFormValues } from '@components/signup/signup.component';
import {createUser, getInvitedUser, getInviteToken, signupInvite, getCampaignToken} from '@services/user/user.actions';
import * as React from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps, withRouter} from "react-router-dom";
import FullScreenCard from '@components/common/fullscreencard/FullScreenCard';
import VarannanVeckaLogo from '@components/svg/varannanvecka';
import {Typography} from "@material-ui/core";
import TranslateNew from "@translate/TranslateNew";
import Button from "@components/common/button/Button";
import Dialog from "@components/common/dialog/dialog.component";
import { IUserCreate } from '@app-types/api/user.types';
import cordovaContext from "src/cordovaContext";

const tn: TranslateNew = TranslateNew.getInstance();

interface IRouteParams {
  token?: string;
}

interface IProps extends RouteComponentProps<IRouteParams> {
  signup: (values: IUserCreate) => void;
  signupInvite: (values: IUserCreate) => void;
  getInvitedUser: (values: any) => void;
  getInviteToken: (values: string) => void;
  getCampaignToken: (email:string) => void;
  user: any;
  errorMessage: string | undefined;
  errorTime: number | undefined;
  inviteToken: string;
  // language: string;
}

interface IState {
  token: string;
  sentToken: string;
  awaitingReply: boolean;
  requestSentTime: number;
  dismissError: number;
  hasSentRequest: boolean;
}

class PSignupContainer extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    let {match: {params: {token}}} = props;

    if (props.errorMessage && props.errorMessage.indexOf("ould not find the invitatio") > -1) {
      token = "";
    }

    if (token) {
      this.props.getInvitedUser(token);
    } else if (props.inviteToken) {
      token = props.inviteToken;
      this.props.getInvitedUser(token);
    }

    props.getInviteToken("x"); // fetching backend stored invite token based on ip
    props.getCampaignToken("x"); // fetching compaign data

    this.state = {
      token: (token ? token : ""),
      sentToken: (token ? token : ""),
      awaitingReply: (!!token),
      requestSentTime: (token ? (Date.now()) : 0),
      dismissError: 0,
      hasSentRequest: !!token,
    };
  }

  public componentDidUpdate(oldProps: IProps) {
    if (oldProps.match !== this.props.match) {
      const {match: {params: {token}}} = this.props;
      if (token && !this.state.hasSentRequest) {
        this.setState({
          token, awaitingReply: true, requestSentTime: Date.now(), sentToken: token, hasSentRequest: true
        });
        this.props.getInvitedUser(token);
      }
    }
    if (this.props.inviteToken !== oldProps.inviteToken && this.props.inviteToken !== undefined && this.props.inviteToken.length > 0) {
      this.props.getInvitedUser(this.props.inviteToken);
      this.setState({token: this.props.inviteToken, awaitingReply: true, requestSentTime: Date.now(), 
        sentToken: this.props.inviteToken, hasSentRequest: true});
    }
    if (this.props.errorMessage && this.props.errorTime && this.props.errorTime > this.state.dismissError) {
      if (this.state.awaitingReply) {
        this.setState({awaitingReply: false});
      }
    }
    if (this.state.hasSentRequest && (this.state.token || this.props.inviteToken) && this.props.user && this.props.user.email) {
      if (this.state.awaitingReply) {
        this.setState({awaitingReply: false});
      }
    }
  }

  public render() {
    let dialog;
    let initialValues:IFormValues = {
      email:(this.props.user.email?this.props.user.email:""),
      firstName:(this.props.user.firstName?this.props.user.firstName:""),
      lastName:(this.props.user.lastName?this.props.user.lastName:""),
      newPassword: '',
      token: this.state.token,
    };

    if (this.props.errorMessage
      && this.props.errorTime
      && this.props.errorMessage.indexOf("uplicate") > -1
      && this.props.errorTime > this.state.dismissError) {
      dialog = this.renderDuplicate();
    } else if (this.props.errorMessage
      && this.props.errorMessage.includes('not find the invitation')
      && this.props.errorTime
      && this.props.errorTime > this.state.dismissError) {
      dialog = this.renderInvalidInviteToken();
    } else if (this.props.user && this.props.user.email) {
      initialValues = {
        email:this.props.user.email,
        firstName:(this.props.user.firstName?this.props.user.firstName:""),
        lastName:(this.props.user.lastName?this.props.user.lastName:""),
        newPassword: '',
        token: this.state.token,
      };
    }

    return (<FullScreenCard sideElement={<VarannanVeckaLogo/>}>
      <Signup
        onSubmit={this.handleSubmit}
        onValidateInviteToken={this.validateInviteToken}
        getInviteToken={(email:string) => this.props.getInviteToken(email)}
        initialValues={initialValues}
        isLoading={this.state.awaitingReply}
      />
      {dialog && (dialog)}
    </FullScreenCard>);
  }

  private renderInvalidInviteToken = () => {
    return (<Dialog
      open={true}
      onClose={() => {
        this.setState({dismissError: Date.now()});
      }}
      content={<Typography variant="body1">
        {tn.lang.signUpInviteError}
      </Typography>}
      actions={<Button
        onClick={() => {
          this.setState({dismissError: Date.now(), token: "", sentToken: ""});
        }}
        color="primary"
        variant="contained"
        size="large"
        autoFocus={true}
        fullWidth={true}
      >
        {tn.lang.tryAgain}
      </Button>}
    />);
  };

  private renderDuplicate = () => {
    return (<Dialog
      open={true}
      onClose={() => {
        this.setState({dismissError: Date.now()});
      }}
      content={<Typography variant="body1">{tn.lang.signUpEmailUsedWithGuide}</Typography>}
      actions={<>
        <Link to={'/login'}>
          <Button>
            {tn.lang.logInButton}
          </Button>
        </Link>
        <Button
          color="primary"
          variant="contained"
          size="large"
          autoFocus={true}
          onClick={() => {
            this.setState({dismissError: Date.now()});
          }}
        >
          {tn.lang.btnUseAnotherEmail}
        </Button>
      </>}
    />);
  };

  private handleSubmit = async (values: IUserCreate) => {
    if (values.token && values.token.length > 1) {
      await this.props.signupInvite(values);
    } else {
      await this.props.signup(values);
    }
  };

  private validateInviteToken = async (token: string) => {
    this.setState({
      awaitingReply: true,
      hasSentRequest: true,
      requestSentTime: Date.now(),
      token, sentToken: token,
    });
    await this.props.getInvitedUser(token);
  };
}

PSignupContainer.contextType = cordovaContext;

function mapStateToProps(state: any) {
  return {
    user: state.user?.session ? state.user.session.data : {},
    errorMessage: state.user?.errorMessage?.message,
    errorTime: state.user?.errorMessage?.id,
    inviteToken: state.user?.session?.inviteToken || "",
  };
}

const mapDispatchToProps = {
  signup: createUser,
  signupInvite,
  getInvitedUser,
  getInviteToken,
  getCampaignToken,
};

const SignupContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(PSignupContainer));

export default SignupContainer;



// WEBPACK FOOTER //
// ./src/containers/signup/signup.container.tsx